module.exports = __webpack_public_path__ + "static/assets/557e3293c95eca88e250cda07e65f21d.svg";